module.exports = __webpack_public_path__ + "img/add-outline.3beb7ee5.svg";